import { Stack, Typography } from '@mui/material'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'

// a null quota means unlimited (shown as ∞); an explicit 0 is shown as 0.
export const formatQuota = quota => (quota == null ? '∞' : quota)

export default function EnrollmentCount({ enrolled, quota, variant = 'body2' }) {
  const count = enrolled ?? 0

  if (quota == null) {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography variant={variant}>{count} /</Typography>
        <AllInclusiveIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      </Stack>
    )
  }

  return (
    <Typography variant={variant} color={count > quota ? 'error.main' : 'text.primary'}>
      {count} / {quota}
    </Typography>
  )
}
